module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "sideBar",
    class: {
      'hidden': !_vm.showSidebar
    }
  }, [_c('DeckEditor')], 1), _vm._v(" "), _c('button', {
    staticClass: "toggleShow",
    class: {
      'shown': _vm.showSidebar
    },
    attrs: {
      "title": "Toggle Sidebar"
    },
    on: {
      "click": function($event) {
        _vm.showSidebar = !_vm.showSidebar
      }
    }
  }, [_c('div', [(_vm.showSidebar) ? [_vm._v("<"), _c('br'), _vm._v("<"), _c('br'), _vm._v("<")] : [_vm._v(">"), _c('br'), _vm._v(">"), _c('br'), _vm._v(">")]], 2)]), _vm._v(" "), _c('div', {
    staticClass: "main",
    class: {
      'withoutSidebar': !_vm.showSidebar
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.backgroundStatus.currentMessage != undefined),
      expression: "backgroundStatus.currentMessage != undefined"
    }],
    staticClass: "headerStatus"
  }, [_vm._v("\n            " + _vm._s(_vm.backgroundStatus.currentMessage) + "\n            "), (_vm.backgroundStatus.currentProgress && _vm.backgroundStatus.maxProgress) ? [_vm._v("\n                [" + _vm._s(_vm.backgroundStatus.currentProgress) + "/" + _vm._s(_vm.backgroundStatus.maxProgress) + "]\n            ")] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "tabContainer"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('span', {
      staticClass: "tab",
      class: {
        'current': _vm.currentTab == tab.id
      },
      attrs: {
        "id": tab.id
      },
      on: {
        "click": function($event) {
          _vm.currentTab = tab.id
        }
      }
    }, [_vm._v(_vm._s(tab.name))])
  })), _vm._v(" "), _c('CardBrowser', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentTab == 'browse'),
      expression: "currentTab == 'browse'"
    }],
    attrs: {
      "allSets": _vm.allSets
    }
  }), _vm._v(" "), _c('Settings', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentTab == 'settings'),
      expression: "currentTab == 'settings'"
    }]
  }), _vm._v(" "), _c('Search', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentTab == 'search'),
      expression: "currentTab == 'search'"
    }]
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0db9a8f2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 126
// module chunks = 0